
const MESSAGE = "Dit veld is verplicht.";

export default (value: string) => {
    return (value === null || value === undefined || value === "") ? MESSAGE : undefined;

}
